export default __webpack_public_path__ + "static/media/Clock.a23860cd.svg";